import React from "react";

export function Input({ className = "", ...props }) {
  return <input className={`np-input ${className}`.trim()} {...props} />;
}

export function Select({ className = "", children, ...props }) {
  return (
    <select className={`np-select ${className}`.trim()} {...props}>
      {children}
    </select>
  );
}

export function Textarea({ className = "", ...props }) {
  return <textarea className={`np-textarea ${className}`.trim()} {...props} />;
}

export function Checkbox({ className = "", children, ...props }) {
  return (
    <label className={`np-check-control ${className}`.trim()}>
      <input type="checkbox" {...props} />
      {children && <span>{children}</span>}
    </label>
  );
}

export function Radio({ className = "", children, ...props }) {
  return (
    <label className={`np-radio-control ${className}`.trim()}>
      <input type="radio" {...props} />
      {children && <span>{children}</span>}
    </label>
  );
}
